import RichContent from '../util/rich/RichContent';

import {ActivityIndicator} from 'antd-mobile';

class Main extends React.Component {
	constructor(props) { 
		super(props); 
	}
	render() {
		const {data} = this.props;
		if (!data) {
			return (
				<div  style={{"position": "fixed", "left": "50%", "top": "50%", "zIndex": "1000", "marginLeft": "-10px", "marginTop": "-10px"}}>
        			<ActivityIndicator animating size="large" />
        		</div>
			)
		}
		var ver = data.ver || [];
		const that = this;
		return (
			 <ul className='csm-timeline' key="b">
			 {
				  ver.map(function(data, index) {
						return (<li>
							<div className="csm-timeline-circle"></div>
							<div className="csm-timeline-content">
								<h3>{that.regVersion(data.version)}</h3>	
								<p style={{'color':'#000'}}>{data.times}</p>
								<p><RichContent value={data.versiondesc} /></p>
							</div>
						</li>)
				  })
			 }
			 </ul>
		)
	}
	regVersion(version) {
		var ary = /(\d\.\d{1,2})\.\d*(.*)/.exec(version);
		return (ary && ary.length && ary.length >= 2) ? ary.slice(1).join("") : version;
	}
}	
export default Main




// WEBPACK FOOTER //
// ./project/components/app/Log.js